module.exports = __webpack_public_path__ + "images/b5f7167380cc17a36c413d0a0cd77b10-CANCUN-WHITE.png";